import { IHttpResponse } from 'angular'
import { GraphQLResponse } from '@vend/types'

/**
 * A little utility function to extract the "data" field of a GraphQL API response.
 *
 * @param responseData An HTTP response from a Vend GraphQL response.
 *
 * @return The contents of the "data" field in the response.
 */
export function extractData<T>({ data }: IHttpResponse<GraphQLResponse<T>>): T {
  if (data.errors && data.errors.length > 0) {
    // Just throw the first error.
    throw new Error(data.errors[0].message)
  }
  return data.data
}
